"use strict";
exports.__esModule = true;
exports.stringifyBlizzardJson = void 0;
function stringifyBlizzardJson(data) {
    return JSON.stringify(data, function (_, v) {
        if (v === null) {
            return undefined;
        }
        if (typeof v === "bigint") {
            return v.toString();
        }
        return v;
    });
}
exports.stringifyBlizzardJson = stringifyBlizzardJson;
//# sourceMappingURL=json.js.map